import { useInView } from '../../hooks/useInView';
import { Check } from 'lucide-react';

const reasons = [
  'Premium botanical ingredients — no fillers, no synthetics',
  'Specifically formulated for male reproductive health',
  'Clean formula with full ingredient transparency',
  'Easy 2-capsule daily routine',
  'Manufactured to the highest quality standards',
  'Trusted by thousands of men across the UK',
];

export default function WhyReloadSection() {
  const [ref, inView] = useInView(0.1);

  return (
    <section
      data-testid="why-reload-section"
      style={{ backgroundColor: '#FFFFFF', padding: '96px 0', overflow: 'hidden' }}
    >
      <div ref={ref} className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-14 items-start">
          {/* Armando image with text overlay */}
          <div className={`fade-up delay-1 ${inView ? 'visible' : ''}`}>
            <div style={{
              position: 'relative',
              borderRadius: '20px',
              overflow: 'hidden',
              backgroundColor: '#BDBBB9',
              width: '100%',
            }}>
              <img
                src="https://customer-assets.emergentagent.com/job_reload-performance/artifacts/sxhfqf7a_Armando.png"
                alt="RELOAD Male Performance"
                data-testid="why-reload-image"
                style={{ width: '100%', display: 'block' }}
              />
              {/* Text overlay */}
              <div style={{
                position: 'absolute',
                top: '8%',
                left: '5%',
                textAlign: 'left',
              }}>
                {['Recharge', 'Recover'].map((word) => (
                  <div key={word} style={{
                    fontFamily: 'Outfit, sans-serif',
                    fontWeight: 800,
                    fontSize: 'clamp(1.8rem, 3.5vw, 3.2rem)',
                    color: '#0D1A2E',
                    lineHeight: 1.05,
                    letterSpacing: '-0.03em',
                  }}>
                    {word}
                  </div>
                ))}
                <div style={{
                  fontFamily: 'Outfit, sans-serif',
                  fontWeight: 800,
                  fontSize: 'clamp(1.8rem, 3.5vw, 3.2rem)',
                  color: '#1B3D7E',
                  lineHeight: 1.05,
                  letterSpacing: '-0.03em',
                }}>
                  Reload.
                </div>
              </div>
            </div>
          </div>

          {/* Text */}
          <div className={`fade-up delay-2 ${inView ? 'visible' : ''}`}>
            <span className="overline block mb-4">Our Promise</span>
            <h2 style={{
              fontFamily: 'Outfit, sans-serif',
              fontWeight: 800,
              fontSize: 'clamp(1.8rem, 3.5vw, 2.6rem)',
              color: '#0D1A2E',
              letterSpacing: '-0.025em',
              lineHeight: 1.15,
              marginBottom: '18px',
            }}>
              Why Choose RELOAD
            </h2>
            <p style={{ fontFamily: 'Manrope, sans-serif', fontSize: '0.95rem', color: '#64748B', lineHeight: 1.85, marginBottom: '24px' }}>
              We built RELOAD because modern men deserve a supplement that actually delivers. No compromises on ingredients. No questionable fillers. Just a clean, effective formula built on science and nature.
            </p>

            <ul style={{ display: 'flex', flexDirection: 'column', gap: '13px', listStyle: 'none' }}>
              {reasons.map((r, i) => (
                <li key={r} data-testid={`why-reason-${i}`} className="flex items-start gap-3">
                  <div style={{ width: '22px', height: '22px', borderRadius: '50%', backgroundColor: 'rgba(27,61,126,0.1)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, marginTop: '1px' }}>
                    <Check size={12} style={{ color: '#1B3D7E' }} strokeWidth={3} />
                  </div>
                  <span style={{ fontFamily: 'Manrope, sans-serif', fontSize: '0.9rem', color: '#0D1A2E', lineHeight: 1.65, fontWeight: 500 }}>{r}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
